export const templateLibraryAdminRoutes = {
  default: 'template_library_admin',
}
